// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Account__SidebarMenuController from "./account/sidebar_menu_controller"

import Account__SidebarScopeController from "./account/sidebar_scope_controller"

import AccountPrefixController from "./account_prefix_controller"

import AccountsReorderController from "./accounts_reorder_controller"

import AfterChangeUpdateController from "./after_change_update_controller"

import AiButtonController from "./ai_button_controller"

import AlertSourceKindToggleController from "./alert_source_kind_toggle_controller"

import AnimatedDropdownController from "./animated_dropdown_controller"

import AppstoreAdditionalCheckboxesController from "./appstore_additional_checkboxes_controller"

import AppstoreCategoryController from "./appstore_category_controller"

import AttachmentDownloaderController from "./attachment_downloader_controller"

import AttachmentViewController from "./attachment_view_controller"

import AutocompleteController from "./autocomplete_controller"

import Automation__CustomFieldFormController from "./automation/custom_field_form_controller"

import Automation__RuleActionsController from "./automation/rule_actions_controller"

import Automation__RuleFormController from "./automation/rule_form_controller"

import BillingCalculateController from "./billing_calculate_controller"

import BoxFadeController from "./box_fade_controller"

import BulkOptionsAdvancedController from "./bulk_options_advanced_controller"

import BulkOptionsController from "./bulk_options_controller"

import Calendar__CalendarDashboardController from "./calendar/calendar_dashboard_controller"

import Calendar__CalendarEventFormController from "./calendar/calendar_event_form_controller"

import Calendar__CalendarRecurrenceController from "./calendar/calendar_recurrence_controller"

import Calendar__CalendarUpcomingController from "./calendar/calendar_upcoming_controller"

import CalendarController from "./calendar_controller"

import CalendarDateJumpController from "./calendar_date_jump_controller"

import CallCenterTicketController from "./call_center_ticket_controller"

import CardsController from "./cards_controller"

import ChartSprintController from "./chart_sprint_controller"

import ChatColumnsController from "./chat_columns_controller"

import ChatTemplateInserterController from "./chat_template_inserter_controller"

import ChatTemplateLoaderController from "./chat_template_loader_controller"

import ClientModalController from "./client_modal_controller"

import Cms__SiteLayoutController from "./cms/site_layout_controller"

import ColumnsReorderController from "./columns_reorder_controller"

import CommentsController from "./comments_controller"

import Commerce__OrderClientController from "./commerce/order_client_controller"

import Commerce__OrderController from "./commerce/order_controller"

import Commerce__ProductSelectController from "./commerce/product_select_controller"

import CommonFormController from "./common_form_controller"

import ContactListKindToggleController from "./contact_list_kind_toggle_controller"

import ContentLocaleSelectController from "./content_locale_select_controller"

import CopyToClipboardController from "./copy_to_clipboard_controller"

import CopyValueController from "./copy_value_controller"

import CountryPrefixController from "./country_prefix_controller"

import Crm__GusLookupController from "./crm/gus_lookup_controller"

import Crm__SmsRecipientController from "./crm/sms_recipient_controller"

import CrmViewController from "./crm_view_controller"

import DashboardTabsController from "./dashboard_tabs_controller"

import DatepickerController from "./datepicker_controller"

import DealTaxController from "./deal_tax_controller"

import DirectUploadFieldController from "./direct_upload_field_controller"

import DismissibleBannerController from "./dismissible_banner_controller"

import DraftController from "./draft_controller"

import DragDropController from "./drag_drop_controller"

import Drive__FileBrowserController from "./drive/file_browser_controller"

import Drive__FileViewController from "./drive/file_view_controller"

import Drive__ShareController from "./drive/share_controller"

import DrivePickerController from "./drive_picker_controller"

import DropdownChangeMultiselectFillController from "./dropdown_change_multiselect_fill_controller"

import DropdownController from "./dropdown_controller"

import DropdownPhotoController from "./dropdown_photo_controller"

import DropdownSearchController from "./dropdown_search_controller"

import DynamicCheckboxController from "./dynamic_checkbox_controller"

import EmailController from "./email_controller"

import EmailNavigationController from "./email_navigation_controller"

import EmployeeLeaveController from "./employee_leave_controller"

import EntryViewController from "./entry_view_controller"

import EscalationStepsController from "./escalation_steps_controller"

import FieldsFormController from "./fields_form_controller"

import FormAttachmentController from "./form_attachment_controller"

import FormsController from "./forms_controller"

import GreedyDropdownController from "./greedy_dropdown_controller"

import HeaderController from "./header_controller"

import HelloController from "./hello_controller"

import HelplinkController from "./helplink_controller"

import IframeController from "./iframe_controller"

import ImageModalController from "./image_modal_controller"

import InfiniteScrollController from "./infinite_scroll_controller"

import InlineCustomFieldController from "./inline_custom_field_controller"

import Insight__ReportChartController from "./insight/report_chart_controller"

import Insight__ReportMetricController from "./insight/report_metric_controller"

import IntumController from "./intum_controller"

import IntumDropzoneController from "./intum_dropzone_controller"

import IntumSelectController from "./intum_select_controller"

import JoditController from "./jodit_controller"

import KanbanDragController from "./kanban_drag_controller"

import Kb__DuplicateRemoverController from "./kb/duplicate_remover_controller"

import Kb__KbTemplateFilterController from "./kb/kb_template_filter_controller"

import Kb__RadioPickerController from "./kb/radio_picker_controller"

import KbReadAccessController from "./kb_read_access_controller"

import KbSearchController from "./kb_search_controller"

import LazySelectController from "./lazy_select_controller"

import LexicalMarkdownController from "./lexical_markdown_controller"

import Mail__PinnedCollapseController from "./mail/pinned_collapse_controller"

import MarkdownEditorController from "./markdown_editor_controller"

import MarkdownPreviewController from "./markdown_preview_controller"

import MemberFieldsController from "./member_fields_controller"

import MenuTabsController from "./menu_tabs_controller"

import ModalController from "./modal_controller"

import ModalViewController from "./modal_view_controller"

import ModuleMenuController from "./module_menu_controller"

import MoreOptionsController from "./more_options_controller"

import MoreOptionsFakturowniaController from "./more_options_fakturownia_controller"

import MultiDropdownController from "./multi_dropdown_controller"

import MultiselectController from "./multiselect_controller"

import MultiselectSearchController from "./multiselect_search_controller"

import NestedFormController from "./nested_form_controller"

import Noe__CodemirrorController from "./noe/codemirror_controller"

import Noe__DbSearchController from "./noe/db_search_controller"

import Noe__LlmChatController from "./noe/llm_chat_controller"

import Noe__RecordFormController from "./noe/record_form_controller"

import Noe__SchemaBuilderController from "./noe/schema_builder_controller"

import NotificationController from "./notification_controller"

import Organize__LeaveCalendarController from "./organize/leave_calendar_controller"

import Organize__TaskCalendarController from "./organize/task_calendar_controller"

import Organize__TaskDeadlineController from "./organize/task_deadline_controller"

import Organize__WorkinfoAutofillController from "./organize/workinfo_autofill_controller"

import PdpTaxSplitController from "./pdp_tax_split_controller"

import PieChartSprintController from "./pie_chart_sprint_controller"

import PriorityController from "./priority_controller"

import PromptDefaultController from "./prompt_default_controller"

import RecurringFormController from "./recurring_form_controller"

import ReloadController from "./reload_controller"

import RolePrivilegesController from "./role_privileges_controller"

import SaveSearchController from "./save_search_controller"

import ScheduleBuilderController from "./schedule_builder_controller"

import ScrollController from "./scroll_controller"

import SelectChangeController from "./select_change_controller"

import SelectController from "./select_controller"

import SelectLoadController from "./select_load_controller"

import SidebarController from "./sidebar_controller"

import SoftphoneController from "./softphone_controller"

import SoundPickerController from "./sound_picker_controller"

import SubscriptionController from "./subscription_controller"

import TagPickerController from "./tag_picker_controller"

import TasksLiveController from "./tasks_live_controller"

import TodoController from "./todo_controller"

import ToggleController from "./toggle_controller"

import TriStateSwitchController from "./tri_state_switch_controller"

import UserSettingFieldsController from "./user_setting_fields_controller"

import WarningController from "./warning_controller"

import WebhookTargetController from "./webhook_target_controller"

import VoipCallRowController from "./voip_call_row_controller"
application.register("account--sidebar-menu", Account__SidebarMenuController)
application.register("account--sidebar-scope", Account__SidebarScopeController)
application.register("account-prefix", AccountPrefixController)
application.register("accounts-reorder", AccountsReorderController)
application.register("after-change-update", AfterChangeUpdateController)
application.register("ai-button", AiButtonController)
application.register("alert-source-kind-toggle", AlertSourceKindToggleController)
application.register("animated-dropdown", AnimatedDropdownController)
application.register("appstore-additional-checkboxes", AppstoreAdditionalCheckboxesController)
application.register("appstore-category", AppstoreCategoryController)
application.register("attachment-downloader", AttachmentDownloaderController)
application.register("attachment-view", AttachmentViewController)
application.register("autocomplete", AutocompleteController)
application.register("automation--custom-field-form", Automation__CustomFieldFormController)
application.register("automation--rule-actions", Automation__RuleActionsController)
application.register("automation--rule-form", Automation__RuleFormController)
application.register("billing-calculate", BillingCalculateController)
application.register("box-fade", BoxFadeController)
application.register("bulk-options-advanced", BulkOptionsAdvancedController)
application.register("bulk-options", BulkOptionsController)
application.register("calendar--calendar-dashboard", Calendar__CalendarDashboardController)
application.register("calendar--calendar-event-form", Calendar__CalendarEventFormController)
application.register("calendar--calendar-recurrence", Calendar__CalendarRecurrenceController)
application.register("calendar--calendar-upcoming", Calendar__CalendarUpcomingController)
application.register("calendar", CalendarController)
application.register("calendar-date-jump", CalendarDateJumpController)
application.register("call-center-ticket", CallCenterTicketController)
application.register("cards", CardsController)
application.register("chart-sprint", ChartSprintController)
application.register("chat-columns", ChatColumnsController)
application.register("chat-template-inserter", ChatTemplateInserterController)
application.register("chat-template-loader", ChatTemplateLoaderController)
application.register("client-modal", ClientModalController)
application.register("cms--site-layout", Cms__SiteLayoutController)
application.register("columns-reorder", ColumnsReorderController)
application.register("comments", CommentsController)
application.register("commerce--order-client", Commerce__OrderClientController)
application.register("commerce--order", Commerce__OrderController)
application.register("commerce--product-select", Commerce__ProductSelectController)
application.register("common-form", CommonFormController)
application.register("contact-list-kind-toggle", ContactListKindToggleController)
application.register("content-locale-select", ContentLocaleSelectController)
application.register("copy-to-clipboard", CopyToClipboardController)
application.register("copy-value", CopyValueController)
application.register("country-prefix", CountryPrefixController)
application.register("crm--gus-lookup", Crm__GusLookupController)
application.register("crm--sms-recipient", Crm__SmsRecipientController)
application.register("crm-view", CrmViewController)
application.register("dashboard-tabs", DashboardTabsController)
application.register("datepicker", DatepickerController)
application.register("deal-tax", DealTaxController)
application.register("direct-upload-field", DirectUploadFieldController)
application.register("dismissible-banner", DismissibleBannerController)
application.register("draft", DraftController)
application.register("drag-drop", DragDropController)
application.register("drive--file-browser", Drive__FileBrowserController)
application.register("drive--file-view", Drive__FileViewController)
application.register("drive--share", Drive__ShareController)
application.register("drive-picker", DrivePickerController)
application.register("dropdown-change-multiselect-fill", DropdownChangeMultiselectFillController)
application.register("dropdown", DropdownController)
application.register("dropdown-photo", DropdownPhotoController)
application.register("dropdown-search", DropdownSearchController)
application.register("dynamic-checkbox", DynamicCheckboxController)
application.register("email", EmailController)
application.register("email-navigation", EmailNavigationController)
application.register("employee-leave", EmployeeLeaveController)
application.register("entry-view", EntryViewController)
application.register("escalation-steps", EscalationStepsController)
application.register("fields-form", FieldsFormController)
application.register("form-attachment", FormAttachmentController)
application.register("forms", FormsController)
application.register("greedy-dropdown", GreedyDropdownController)
application.register("header", HeaderController)
application.register("hello", HelloController)
application.register("helplink", HelplinkController)
application.register("iframe", IframeController)
application.register("image-modal", ImageModalController)
application.register("infinite-scroll", InfiniteScrollController)
application.register("inline-custom-field", InlineCustomFieldController)
application.register("insight--report-chart", Insight__ReportChartController)
application.register("insight--report-metric", Insight__ReportMetricController)
application.register("intum", IntumController)
application.register("intum-dropzone", IntumDropzoneController)
application.register("intum-select", IntumSelectController)
application.register("jodit", JoditController)
application.register("kanban-drag", KanbanDragController)
application.register("kb--duplicate-remover", Kb__DuplicateRemoverController)
application.register("kb--kb-template-filter", Kb__KbTemplateFilterController)
application.register("kb--radio-picker", Kb__RadioPickerController)
application.register("kb-read-access", KbReadAccessController)
application.register("kb-search", KbSearchController)
application.register("lazy-select", LazySelectController)
application.register("lexical-markdown", LexicalMarkdownController)
application.register("mail--pinned-collapse", Mail__PinnedCollapseController)
application.register("markdown-editor", MarkdownEditorController)
application.register("markdown-preview", MarkdownPreviewController)
application.register("member-fields", MemberFieldsController)
application.register("menu-tabs", MenuTabsController)
application.register("modal", ModalController)
application.register("modal-view", ModalViewController)
application.register("module-menu", ModuleMenuController)
application.register("more-options", MoreOptionsController)
application.register("more-options-fakturownia", MoreOptionsFakturowniaController)
application.register("multi-dropdown", MultiDropdownController)
application.register("multiselect", MultiselectController)
application.register("multiselect-search", MultiselectSearchController)
application.register("nested-form", NestedFormController)
application.register("noe--codemirror", Noe__CodemirrorController)
application.register("noe--db-search", Noe__DbSearchController)
application.register("noe--llm-chat", Noe__LlmChatController)
application.register("noe--record-form", Noe__RecordFormController)
application.register("noe--schema-builder", Noe__SchemaBuilderController)
application.register("notification", NotificationController)
application.register("organize--leave-calendar", Organize__LeaveCalendarController)
application.register("organize--task-calendar", Organize__TaskCalendarController)
application.register("organize--task-deadline", Organize__TaskDeadlineController)
application.register("organize--workinfo-autofill", Organize__WorkinfoAutofillController)
application.register("pdp-tax-split", PdpTaxSplitController)
application.register("pie-chart-sprint", PieChartSprintController)
application.register("priority", PriorityController)
application.register("prompt-default", PromptDefaultController)
application.register("recurring-form", RecurringFormController)
application.register("reload", ReloadController)
application.register("role-privileges", RolePrivilegesController)
application.register("save-search", SaveSearchController)
application.register("schedule-builder", ScheduleBuilderController)
application.register("scroll", ScrollController)
application.register("select-change", SelectChangeController)
application.register("select", SelectController)
application.register("select-load", SelectLoadController)
application.register("sidebar", SidebarController)
application.register("softphone", SoftphoneController)
application.register("sound-picker", SoundPickerController)
application.register("subscription", SubscriptionController)
application.register("tag-picker", TagPickerController)
application.register("tasks-live", TasksLiveController)
application.register("todo", TodoController)
application.register("toggle", ToggleController)
application.register("tri-state-switch", TriStateSwitchController)
application.register("user-setting-fields", UserSettingFieldsController)
application.register("warning", WarningController)
application.register("webhook-target", WebhookTargetController)
application.register("voip-call-row", VoipCallRowController)
